/**
 * 以下所有数值均可在 OSS 上配置 json文件 详情见 ossService.ts
 * */

//小游戏跳转信息
export interface JumpMiniGameConfig {
    //
    appId: string;
    //
    iconId: string;
    //
    name: string;
}

export default class {
    /** 数值配置 start **/
    static readonly COPY: string = '@长沙零动科技';
    //游戏名字
    static readonly GAME_NAME: string = '基础框架';
    //跳转小游戏列表 格子 目前只支持微信
    static readonly MINI_GAME_JUMP_CELL_LIST: JumpMiniGameConfig[] = [
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
    ];
    //跳转小游戏列表 滚动 目前只支持微信
    static readonly MINI_GAME_JUMP_SCROLL_LIST: JumpMiniGameConfig[] = [
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生1', iconId: 'wsys', appId: 'wx75542a90a4f3b540' }
    ];
    //跳转小游戏列表 侧拉栏 目前只支持微信
    static readonly MINI_GAME_JUMP_SIDE_LIST: JumpMiniGameConfig[] = [
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生1', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生2', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生3', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生4', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生5', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生6', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生7', iconId: 'wsys', appId: 'wx75542a90a4f3b540' },
        { name: '-老乡你要啥', iconId: 'lxnys', appId: 'wxc7d2241fc9e870aa' },
        { name: '-我是医生8', iconId: 'wsys', appId: 'wx75542a90a4f3b540' }
    ];
    //分享录屏描述
    static readonly GAME_VIDEO_SHARE_DESC: string = '基础框架';
    //分享录屏标题
    static readonly GAME_VIDEO_SHARE_TITLE: string = '基础框架';
    //版本公告
    static readonly VERSION_NOTICE: string = '';
    //默认体力/最大体力
    static readonly MAX_POWER: number = 10;
    //初始化力
    static readonly NORMAL_POWER: number = 15;
    //初始金币
    static readonly NORMAL_COINS: number = 0;
    //初始钻石
    static readonly NORMAL_DIAMONDS: number = 10;
    //观看视频获得体力
    static readonly ADD_ONCE_POWER: number = 5;
    //观看视频获得金币
    static readonly ADD_ONCE_COINS: number = 100;
    //观看视频获得钻石
    static readonly ADD_ONCE_DIAMONDS: number = 100;
    //体力恢复周期时间 秒
    static readonly REST_POWER_TIME: number = 60;
    //体力恢复周期 恢复量
    static readonly REST_POWER_VALUE: number = 1;
    //第一次进入游戏弹出无限体力概率
    static readonly FIRST_PLAY_INFINITY_PROBABILITY: number = 1;
    //无限体力看视频次数
    static readonly INFINITY_POWER_VIDEO_COUNT: number = 3;
    //点击添加体力弹出无限体力概率
    static readonly CLICK_POWER_INFINITY_PROBABILITY: number = 1;
    //启用日志服务
    static readonly LOG_SERVICE_OPEN: boolean = false;
    //屏幕日志开关
    static readonly SCREEN_LOG_SWITCH: boolean = false;
    //打印日志等级 [0-5 对应  debug,log,info,warn,error,empty]
    static readonly CONSOLE_LOG_LEVEL: number = 2;
    //全屏视频时间 秒
    static readonly FULL_SCREEN_VIDEO_TIME: number = 30;
    /** 是否开启日志打印 */
    static readonly IS_OPEN_CLOG: boolean = false;
    /** 打劫匪一次广告复活次数 */
    static readonly AD_HIT_ROB_COUNT: number = 2;

    /** 言出法随给的广告卡数量 */
    static readonly SUPER_POWER_AD_CARD_COUNT: number = 10;

    /** 生10个女儿获得随字 */
    static readonly GRIL_COUNT_AWARD_SUI: number = 10;
    /** 是否开启跳剧情 */
    static readonly OPEN_SKIP_PLOT: boolean = true;



    //  ----------VIVO 平台开关
    //返回首页弹出模板广告概率
    static BACK_MAIN_QT_TEMPLATEGL: number = 1;
    //模板广告关闭强弹概率
    static TEMPLATEN_AD_QT_GL: number = 1;
    //模板广告弹出概率
    static TEMPLATENA_CX_GL: number = 1;


    //废弃功能****************
    //新手保护时间
    static readonly FIRST_VIDEO_TIME: number = 0;
    //废弃功能***************

    //地区屏蔽 "北京","上海","深圳","广州","重庆","天津","杭州","南京","成都","长沙"
    static readonly IP_BLOCK_CITY: string[] = [];

    //抖音预埋
    static readonly DOUYIN_YUMAI: number = 0;

    /**
     * 游戏相关分隔
     */
    static readonly LOTTERY_SECONDS: number = 60;//开奖时间

    static readonly LOTTERY_FFC_BET_COINS: number = 2;//20元一注

    static readonly HOUR_COST_STRONGER_VALUE: number = 1;//跳过关卡，每小时花费体力
    //Stronger
    static readonly ALIVE_STRONGER_COUNT: number = 50;
    static readonly ALIVE_MOOD_COUNT: number = 50;
    static readonly ALIVE_HEALTH_COUNT: number = 50;

    static readonly ONEDAY_TALENT_COUNT: number[] = [1, 1, 1];

    static readonly LOTTERY_FIVE_ARY: number[][] = [
        [1, 10, 11, 21, 12],
    ];

    static readonly LOTTERY_FOUR_ARY: number[][] = [
        [20, 23, 2, 1, 22]
    ];

    static readonly LOTTERY_THREE_ARY: number[][] = [
        [16, 6, 18, 8, 20]
    ];

    /**
     * add
     */
    static readonly FEE_RATE_NUM = 0.5;//每次价格的涨幅
    static readonly FEE_RATE_INTERVALS_DAYS = 5;//相隔5天物价增长一次

    static readonly AUCTION_DAY_COUNT: number = 3;

    static readonly TODAY_EVENT_COUNT: number = 2;

    /**大概率增值的股票 */
    static readonly STOCK_PRICE_ADD: string = "亡者农药";


    /**
     *
     */
    static readonly GGL_CURR_LIMIT : number = 2;//ggl 当天限制次数
    static readonly HJGGL_CURR_LIMIT : number = 1;//ggl 当天限制次数
    static readonly SUPER_GGL_CURR_LIMIT : number = 2;//ggl 当天限制次数
    static readonly NEW_GGL_CURR_LIMIT : number = 1;//新ggl 当天限制次数
    static readonly NEW_GGL_CURR_LIMIT2 : number = 10000000000;//新ggl 当天限制次数

    /** 雀神 当前限制次数 */
    static readonly LOTTERY_QUE_SHEN_LIMIT = 5;
    /** 名堂 当前限制次数 */
    static readonly LOTTERY_MING_TANG_LIMIT = 5;
    /** 橙意满满 当前限制次数 */
    static readonly LOTTERY_CHENG_YI_MANMAN_LIMIT = 10000000000;
    /** 金花大乱斗 当前限制次数 */
    static readonly LOTTERY_JIN_HUA_LIMIT = 1;
    /** 快乐中中中 当前限制次数 */
    static readonly LOTTERY_HAPPY_WIN_LIMIT = 5;
    
    /** 摸牌挑战 当前限制次数 */
    static readonly TOUCH_CARD_CHALLENGE_LIMIT = 5;
    /** 摸牌挑战 当前限制次数 */
    static readonly SELECT_CARD_CHALLENGE_LIMIT = 5;


    // static readonly GGL_NORMAL_WEIGHT : number = 3;//刮刮乐 开奖 控制系数，数字越大概念越低
    static readonly NEW_GGL_NORMAL_WEIGHT : number = 1;//刮刮乐 开奖 控制系数，数字越大概念越低
    // static readonly GGL_GOLD_WEIGHT : number = 1.5;//黄金刮刮乐 开奖控制系数

    static readonly ADD_DESTOK_SUCCESS_COIN:number = 10000;

    static readonly CLAMSHELL_CUT_COUNT:number = 3;

    static readonly OPEN_ORE_CUT_COUNT:number = 12;

    static readonly GAMBLER_EVENT_PRO:number = 0.1;

    static readonly LAKE_ADD_COINS : number = 1;//西湖 青蛙点击增加金币数量 +1

    static readonly STALL_VIP_TIME :number = 60;

    static readonly BOSS_VALUATION_RATIO:number[] = [0.8,2];

    static readonly ATTENTION_TIME:number = 10;

    /** 切木头 */
    static readonly GAMBLER_CUT_COUNT:number = 6;
    static readonly GAMBLER_SPECIAL_EVENT_PRO:number = 0.1;

    //上涨的概率
    static readonly INVEST_RISE_PRO:number = 0.4;
    //上涨和下跌的最大幅度
    static readonly INBEST_RISE_MAX_MIN_RADIO:number[] = [-2.5,2.5];
    //鸡窝，鸡蛋的数量上限
    static readonly NEST_EGG_COUNT : number = 100;
    //漂流瓶 次数
    static readonly DRIFT_BATTLE_COUNT : number = 5;
    //闲置提示判定秒数
    static readonly IDLE_NOTICE_SECONDS : number = 50;
    //每隔多少天递增
    static readonly ADD_INTERVAL_DAYS : number = 2;
    //每隔递增多少
    static readonly INTERVAL_ADD_NUM : number = 0.1;
    //鸡分钟 换算 时间的秒数 值
    static readonly CHICKEN_SECONDS_RATE : number = 3;
    //摆盘 翻倍率
    static readonly SWING_PLATE_RATE : number = 10;
    //护镖每日可玩次数
    static readonly DART_EVERY_DAY_CAN_PLAY_COUNT:number = 3;
}














